import { FilterSettingsCacheStoreFactory } from 'common/data/filter-settings/cache/store.factory';
import { FilterSettingsStoreFactory as FilterSettingsStoreDataFactory } from 'common/data/filter-settings/store.factory';
import { FilterSettingsStore } from 'common/module/filter/settings/store';

export function FilterSettingsStoreFactory(): FilterSettingsStore {
  return new FilterSettingsStore(FilterSettingsCacheStoreFactory(), FilterSettingsStoreDataFactory());
}
